import React from 'react';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Icon from "../../../../components/icon/Icon"
import HeaderDisputeStatus from './HeaderDisputeStatus';



const CardDispute = ({ orders, selectedCard, handleCardClick, estadoSelected, handleChangeStatus }) => {
    return (
        <>
        <div style={{ width: '25%', position: 'relative', bottom: -30} }>
            <HeaderDisputeStatus stateSelected={estadoSelected} handleChangeStatus={handleChangeStatus} />
            <div style={{
                width: '100%',
                borderTop: '1px solid #ccc',
                margin: '20px 0',
            }} />
            <div style={{
                height: '120vh',
                overflowY: 'auto',
                padding: '15px'
            }}>
                {orders.map((card) => (
                    <Card
                        key={card.id}
                        onClick={() => handleCardClick(card)}
                        style={{
                            cursor: 'pointer',
                            backgroundColor:
                                selectedCard?.id === card.id ? '#6c5dd3' : '#ffff',
                            color: selectedCard?.id === card.id ? '#ffff' : '#000',
                            marginBottom: '1rem',
                        }}>
                        <CardBody>
                            <h5>
                                <strong>{card.orderNumber}</strong>
                            </h5>
                            <p>{card.date.toDate().toLocaleString()}</p>
                            <p>{card.clientName}</p>
                            {selectedCard?.id !== card.id && (
                                <span

                                    style={{

                                        position: 'absolute',
                                        top: 12,
                                        padding: '5px 15px',
                                        right: 12,
                                        borderRadius: '12px',
                                        backgroundColor:
                                            card.disputeStatus === 'HSD'
                                                ? '#F3542155'
                                                : card.disputeStatus === 'HSS'
                                                    ? '#46bcaa' : '#000',

                                        color: card.disputeStatus === 'HSD'
                                            ? '#F35421'
                                            : card.disputeStatus === 'HSS'
                                                ? '#ffff' : '#000',
                                        fontSize: '1.0rem',
                                    }}
                                >
                                    <Icon style={{ marginRight: '5px', color: card?.disputeStatus === 'HSD' ? '#F35421' : '#ffffff' }} icon='record-circle' />
                                    {card.disputeStatus === 'HSD'
                                        ? 'Aberto'
                                        : card.disputeStatus === 'HSS'
                                            ? 'Finalizado'
                                            : ''}
                                </span>
                            )}

                        </CardBody>
                    </Card>
                ))}
            </div>
            </div>
        </>
    )
}

export default CardDispute